import styled from 'styled-components'
import { MyCollaboInfoCard } from 'src/components/Global/Cards/Cards'
import { Slider } from 'src/components/Global/Slider/Slider'
import { CollaboDescText } from 'src/components/Global/Text/TitleText'
import { NoCollabo } from './NoCollabo'
import { useTypedSelector } from 'src/redux/root-reducer'
import { getAllCollaboAction } from 'src/redux/actions/collaboAction'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
const MyCollaboWrapper = styled.div`
  width: 100%;
  p {
    font-family: ${({ theme }) => theme.fontFamily.inter};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 22px;
    color: ${({ theme }) => theme.colors.darkShade};
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.x4};
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .name {
    padding-left: 20px;
    padding-top: 20px;
  }
  .collaboImg {
    width: 40px;
    height: 40px;
    padding-top: 23px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 40px;
      height: 40px;
      padding-top: 5px;
    }
  }
  .seventy {
    width: 85%;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 90%;
    }
  }
  .thirty {
    width: 25%;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 10%;
    }
  }
  .slide {
    display: flex;
    width: 87%;
    align-items: center;
    margin-top: -23px;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      margin-top: -20px;
      width: 90%;
    }
    .value {
      padding-left: 43px;
      font-family: ${({ theme }) => theme.fontFamily.visuelt};
      font-style: normal;
      font-weight: bold;
      font-size: 55.3961px;
      color: ${({ theme }) => theme.colors.CollaboBlue};
      @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
        font-size: ${({ theme }) => theme.fontSize.x2};
        padding-left: 13px;
      }
    }
  }
`

const MyCollabo = () => {
  const mycollabo = useTypedSelector((state) => state.collabo.all)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllCollaboAction())
  }, [dispatch])

  return (
    <MyCollaboWrapper>
      {mycollabo.length > 0 ? (
        <div>
          {mycollabo.map((item: any) => (
            <MyCollaboInfoCard key={item.collabo_id}>
              <CollaboDescText>{item.group_name}</CollaboDescText>
              <div className="flex">
                <img src={item.image_url} alt="" className="collaboImg" />
                <h4 className="name">{item.created_by}</h4>
              </div>
              <p>Progress</p>
              <div className="slide">
                <div className="seventy">
                  <Slider
                    width={
                      item.plan.progress_percent >= '100'
                        ? '100%'
                        : `${item.plan.progress_percent}%`
                    }
                  />
                </div>
                <div className="thirty">
                  <p className="value">
                    {item.plan.progress_percent >= '100'
                      ? '100%'
                      : `${item.plan.progress_percent}%`}
                  </p>
                </div>
              </div>
            </MyCollaboInfoCard>
          ))}
        </div>
      ) : (
        <NoCollabo>You have no collabo yet</NoCollabo>
      )}
    </MyCollaboWrapper>
  )
}

export { MyCollabo }
